/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Trash_SubtitleInputs */

const cs_documents_trash_subtitle = /** @type {(inputs: Documents_Trash_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft-smazané složky a soubory.`)
};

const en_documents_trash_subtitle = /** @type {(inputs: Documents_Trash_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soft-deleted folders and files.`)
};

/**
* | output |
* | --- |
* | "Soft-deleted folders and files." |
*
* @param {Documents_Trash_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_trash_subtitle = /** @type {((inputs?: Documents_Trash_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Trash_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_trash_subtitle(inputs)
	return cs_documents_trash_subtitle(inputs)
});